import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function FinancialConsulting() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('services.service3.title')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="service-detail">
            <div className="service-description">
              <h2>Përshkrimi i Shërbimit</h2>
              <p>{t('services.service3.desc')}</p>
              <p>Shërbimi ynë i konsulencës financiare përfshin:</p>
              <ul>
                <li>Planifikim strategjik financiar</li>
                <li>Këshillim për investime dhe financim</li>
                <li>Analizë e strukturës së kapitalit</li>
                <li>Optimizimi i burimeve financiare</li>
                <li>Strategji për rritjen e biznesit</li>
              </ul>
            </div>
            
            <div className="service-benefits">
              <h2>Përfitimet</h2>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <h3>Strategji të Qarta</h3>
                  <p>Planifikim i detajuar për zhvillimin e biznesit</p>
                </div>
                <div className="benefit-card">
                  <h3>Optimizimi i Investimeve</h3>
                  <p>Këshillim për investimet më fitimprurëse</p>
                </div>
                <div className="benefit-card">
                  <h3>Menaxhim i Rrezikut</h3>
                  <p>Identifikimi dhe minimizimi i rreziqeve financiare</p>
                </div>
                <div className="benefit-card">
                  <h3>Rritje e Fitimit</h3>
                  <p>Strategji për maksimizimin e fitimeve</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FinancialConsulting; 